/**
 * @Author: HJK
 * @Date: 2023-06-06 11:50:51
 * @LastEditTime: 2023-09-15 13:10:02
 * @LastEditors: HJK
 * @Description: 
 * @FilePath: \badayuan-frontend\src\filters\index.js
 */
// import  serverApi from "@/api/model/serverApi.js";
import Vue from "vue";
// const BASEURL = serverApi.BASEURL;

// const BASEURL = "https://badayuan.bj.bcebos.com/";
const BASEURL = process.env.NODE_ENV === "production" ? "/" : "https://badayuan.bj.bcebos.com/";


const filters = [
    {
        name: "getPathByAddBaseUrl",//所有图片的地址加前缀规则
        func: (path) => {
            return BASEURL + path;
        }
    }
]
filters.forEach(item => {
    Vue.filter(item.name, item.func);
})

export default BASEURL;


// WEBPACK FOOTER //
// ./src/filters/index.js